const Acordo = () => import('../../spa/acordo/Acordo');
const TelaAcordo = () => import('../../spa/acordo/TelaAcordo');

export default {
  path: 'acordo',
  component: TelaAcordo,
  children: [
    {
      path: '',
      name: 'acordo',
      component: Acordo,
    },
  ],
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/acordo.js